module.exports = __webpack_public_path__ + "static/media/left.458ef02b.svg";